
import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useFormValidation } from "@/hooks/use-form-validation";
import { MaskedInput } from "@/components/ui/masked-input";
import { useLogger } from "@/utils/logging/logger";

export const PhoneLoginForm: React.FC = () => {
  const logger = useLogger('PhoneLoginForm');
  const { signInWithPhone } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  
  const { form, handleChange, validateForm } = useFormValidation(
    {
      phoneNumber: '',
    },
    {
      phoneNumber: { 
        required: true, 
        pattern: /^\+?[0-9]{10,15}$/
      }
    }
  );
  
  const handleSubmit = async (e: React.FormEvent): Promise<void> => {
    e.preventDefault();
    
    if (!validateForm()) return;
    
    setIsLoading(true);
    try {
      if (signInWithPhone) {
        await signInWithPhone(form.phoneNumber.value);
      }
    } catch (error) {
      logger.error('Phone login error', error);
    } finally {
      setIsLoading(false);
    }
  };
  
  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="phoneNumber">Номер телефона</Label>
        <div className="flex">
          <MaskedInput
            id="phoneNumber"
            name="phoneNumber"
            mask="+9 (999) 999-99-99"
            placeholder="+7 (123) 456-78-90"
            value={form.phoneNumber.value}
            onChange={handleChange}
            className={form.phoneNumber.error && form.phoneNumber.touched ? "border-destructive" : ""}
          />
        </div>
        {form.phoneNumber.error && form.phoneNumber.touched && (
          <p className="text-sm text-destructive">{form.phoneNumber.error}</p>
        )}
        <p className="text-xs text-muted-foreground">
          Мы отправим вам код подтверждения по SMS
        </p>
      </div>
      <Button type="submit" className="w-full" disabled={isLoading}>
        {isLoading ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : null}
        Получить код
      </Button>
    </form>
  );
};
